module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-okinawa-churaumi-aquarium-a23204c5f146f93d14fba566e5697104.webp";